import React from 'react';
import {
  Modal as CModal,
  ModalBody as CModalBody,
  ModalProps as CModalProps,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';

interface StaticModalComponents {
  Body: typeof CModalBody;
  CloseButton: typeof ModalCloseButton;
  Content: typeof ModalContent;
  Header: typeof ModalHeader;
  Footer: typeof ModalFooter;
  Overlay: typeof ModalOverlay;
}

export interface ModalProps extends CModalProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full'; // CModalProps['size']
}

export const Modal: React.FC<ModalProps> & StaticModalComponents = (props) => <CModal {...props} />;

Modal.Body = CModalBody;
Modal.Header = ModalHeader;
Modal.Content = ModalContent;
Modal.Footer = ModalFooter;
Modal.CloseButton = ModalCloseButton;
Modal.Overlay = ModalOverlay;
